/** App semver from root package.json, injected at build time via vite.config.mts */
export const APP_VERSION = __MALU_APP_VERSION__

/** Short git commit SHA at build time, injected via vite.config.mts */
export const APP_GIT_SHA = __MALU_GIT_SHA__
